import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    inject,
    OnDestroy,
    OnInit,
    QueryList,
    ViewChildren,
    ViewEncapsulation,
} from '@angular/core';
import { BazisToastService, TOAST_GROUPS } from '@bazis/shared/services/toast.service';
import { map } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { SignStatusModule } from '@bazis/shared/components/web/sign-status/sign-status.module';
import { IconModule } from '@bazis/shared/components/web/icon/icon.module';
import { ColorDirective } from '@bazis/shared/directives/color.directive';
import { TranslocoModule } from '@jsverse/transloco';
import { TimerModule } from '../web/timer/timer.module';
import { LinkModule } from '../web/link/link.module';
import { ToastTimer } from '@bazis/shared/models/toast.types';

@Component({
    selector: 'bazis-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['toast.component.scss'],
    imports: [
        CommonModule,
        SignStatusModule,
        IconModule,
        ColorDirective,
        TranslocoModule,
        TimerModule,
        LinkModule,
    ],
    encapsulation: ViewEncapsulation.ShadowDom,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent {
    @ViewChildren('popoverToastGroup') set popoverToastGroupEl(qlist: QueryList<ElementRef>) {
        if (!qlist || qlist.toArray().length === 0) return;

        qlist.toArray().forEach((element) => {
            element.nativeElement.showPopover();
        });
    }

    public toastService = inject(BazisToastService);

    // TODO: подумать можно ли переделать в web-компонент, - есть мысль уйти от веб компонентов

    groupNames = TOAST_GROUPS;

    currentGroups$ = this.toastService.toastGroups.$.pipe(
        map((groups) => {
            return this.groupNames.filter((group) => groups[group].length);
        }),
    );

    dismiss(id, group) {
        this.toastService.dismiss(id, group);
    }

    cancelTimer(timer: ToastTimer, id, group) {
        if (timer.cancelHandler) {
            timer.cancelHandler();
        }
        this.dismiss(id, group);
    }
}
